import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

interface DeleteConfirmationDialogProps {
  open: boolean;
  userName: string;
  onClose: () => void;
  onDelete: () => void;
}

const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({
  open,
  userName,
  onClose,
  onDelete,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6">Eliminar usuario</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <Typography>
          ¿Estás seguro de que quieres eliminar a <strong>{userName}</strong>?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="error"
          fullWidth
          onClick={onDelete}
          style={{ textTransform: 'none' }}
        >
          Eliminar
        </Button>
        <Button
          variant="contained"
          color="inherit"
          fullWidth
          onClick={onClose}
          style={{
            backgroundColor: '#e0e0e0',
            color: '#424242',
            textTransform: 'none',
          }}
        >
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
